module.exports = __webpack_public_path__ + "static/media/Test-start.0bceb293.mp3";